import React from 'react';
import Image from 'react-bootstrap/Image';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Table from 'react-bootstrap/Table';
import Tabla from '../Tabla';
import MatchList from '../MatchList';
import MatchCardGroup from '../MatchCardGroup';
import Players from '../Players';
import ToggleButtonGroup from 'react-bootstrap/ToggleButtonGroup';
import ToggleButton from 'react-bootstrap/ToggleButton';
import TablaProm2005 from '../TablaProm2005';
class Clausura2005 extends React.Component {

  constructor(props){
    super(props);
        this.comeBack = this.comeBack.bind(this);
	this.handleChange = this.handleChange.bind(this);
	var id_list = [];
	for (var i = 417; i <= 437; i++) {
              id_list.push(i);
        }
    this.state = {
	showCards: true,
      path: this.props.path,
      ctype: this.props.ctype,
	kit_path: '/images/kits/todas/',
      kits: [],
      torneo: this.props.torneo,
      id_list: id_list,
      table1:[
		{'color':'#295e1e','shortname':'colocolo', 'rivalName':'Colo Colo', 'pj':19, 'pg':13,'pe':5,'pp':1,'gf':47,'gc':17,'dif':30, 'pts':44},
		{'color':'#295e1e','shortname':'udeconce', 'rivalName':'U. de Concepción', 'pj':19, 'pg':8,'pe':3,'pp':8,'gf':27,'gc':28,'dif':-1, 'pts':27},
		{'color':0,'shortname':'coquimbo', 'rivalName':'Coquimbo Unido', 'pj':19, 'pg':3,'pe':6,'pp':10,'gf':18,'gc':30,'dif':-12, 'pts':15},
		{'color':0,'shortname':'melipilla', 'rivalName':'Melipilla', 'pj':19, 'pg':6,'pe':2,'pp':11,'gf':17,'gc':23,'dif':-6, 'pts':20},
		{'color':0,'shortname':'union', 'rivalName':'U. Española', 'pj':19, 'pg':6,'pe':6,'pp':7,'gf':27,'gc':28,'dif':-1, 'pts':24}
	],

	table2:[{'color':'#295e1e','shortname':'cobreloa', 'rivalName':'Cobreloa', 'pj':19, 'pg':6,'pe':5,'pp':8,'gf':23,'gc':21,'dif':2, 'pts':23},
              {'color':0,'shortname':'audax', 'rivalName':'Audax Italiano', 'pj':19, 'pg':4,'pe':6,'pp':9,'gf':24,'gc':32,'dif':-8, 'pts':18},
              {'color':0,'shortname':'puertomontt', 'rivalName':'Puerto Montt', 'pj':19, 'pg':5,'pe':3,'pp':11,'gf':17,'gc':31,'dif':-14, 'pts':18},
	      {'color':'#295e1e','shortname':'udeconce', 'rivalName':'U. de Concepción', 'pj':19, 'pg':8,'pe':3,'pp':8,'gf':27,'gc':28,'dif':-1, 'pts':27},
              {'color':'#295e1e','shortname':'catolica', 'rivalName':'U. Católica', 'pj':19, 'pg':15,'pe':4,'pp':0,'gf':33,'gc':3,'dif':30, 'pts':49},
              {'color':'#135683','shortname':'colocolo', 'rivalName':'Colo Colo', 'pj':19, 'pg':13,'pe':5,'pp':1,'gf':47,'gc':17,'dif':30, 'pts':44},
              {'color':'#295e1e','shortname':'cobresal', 'rivalName':'Cobresal', 'pj':19, 'pg':8,'pe':4,'pp':7,'gf':30,'gc':24,'dif':6, 'pts':28},
              {'color':'#295e1e','shortname':'huachipato', 'rivalName':'Huachipato', 'pj':19, 'pg':10,'pe':4,'pp':5,'gf':31,'gc':20,'dif':11, 'pts':34},
              {'color':'#295e1e','shortname':'udechile', 'rivalName':'U. de Chile', 'pj':19, 'pg':11,'pe':5,'pp':3,'gf':34,'gc':24,'dif':10, 'pts':38},
              {'color':0,'shortname':'rangers', 'rivalName':'Rangers', 'pj':19, 'pg':4,'pe':6,'pp':9,'gf':24,'gc':32,'dif':-8, 'pts':18},
              {'color':0,'shortname':'wanderers', 'rivalName':'S. Wanderers', 'pj':19, 'pg':6,'pe':5,'pp':8,'gf':17,'gc':23,'dif':-6, 'pts':23},
              {'color':0,'shortname':'union', 'rivalName':'U. Española', 'pj':19, 'pg':6,'pe':6,'pp':7,'gf':27,'gc':28,'dif':-1, 'pts':24},
              {'color':0,'shortname':'temuco', 'rivalName':'Dep. Temuco', 'pj':19, 'pg':6,'pe':1,'pp':12,'gf':17,'gc':39,'dif':-22, 'pts':19},
	      {'color':'#295e1e','shortname':'laserena', 'rivalName':'La Serena', 'pj':19, 'pg':6,'pe':6,'pp':7,'gf':24,'gc':24,'dif':0, 'pts':24},
	      {'color':0,'shortname':'everton', 'rivalName':'Everton', 'pj':19, 'pg':5,'pe':8,'pp':6,'gf':23,'gc':22,'dif':1, 'pts':23},
              {'color':0,'shortname':'palestino', 'rivalName':'Palestino', 'pj':19, 'pg':5,'pe':8,'pp':6,'gf':23,'gc':22,'dif':1, 'pts':23},
              {'color':0,'shortname':'sanfelipe', 'rivalName':'U. San Felipe', 'pj':19, 'pg':6,'pe':5,'pp':8,'gf':24,'gc':23,'dif':1, 'pts':23},
	      {'color':0,'shortname':'concepcion', 'rivalName':'Dep. Concepción', 'pj':19, 'pg':9,'pe':6,'pp':4,'gf':28,'gc':24,'dif':4, 'pts':33},
              {'color':0,'shortname':'melipilla', 'rivalName':'Melipilla', 'pj':19, 'pg':6,'pe':2,'pp':11,'gf':17,'gc':23,'dif':-6, 'pts':20},
              {'color':0,'shortname':'coquimbo', 'rivalName':'Coquimbo Unido', 'pj':19, 'pg':3,'pe':6,'pp':10,'gf':18,'gc':30,'dif':-12, 'pts':15}],

		  table3:[
  {'color':0,'shortname':'catolica', 'rivalName':'U. Católica', 'pts03':44, 'pon03':8.8,'pts04':51,'pon04':15.3,'pts05':93,'pon05':46.5,'pon':70.6},
  {'color':0,'shortname':'colocolo', 'rivalName':'Colo Colo', 'pts03':55, 'pon03':11,'pts04':65,'pon04':19.5,'pts05':76,'pon05':38,'pon':68.5},
  {'color':0,'shortname':'udechile', 'rivalName':'U. de Chile', 'pts03':43, 'pon03':8.6,'pts04':57,'pon04':17.1,'pts05':77,'pon05':38.5,'pon':64.2},
  {'color':0,'shortname':'concepcion', 'rivalName':'Dep. Concepción', 'pts03':0, 'pon03':0,'pts04':0,'pon04':0,'pts05':61,'pon05':61,'pon':61},
  {'color':0,'shortname':'cobreloa', 'rivalName':'Cobreloa', 'pts03':53, 'pon03':10.6,'pts04':62,'pon04':18.6,'pts05':56,'pon05':28,'pon':57.2},
  {'color':0,'shortname':'huachipato', 'rivalName':'Huachipato', 'pts03':41, 'pon03':8.2,'pts04':47,'pon04':14.1,'pts05':65,'pon05':32.5,'pon':54.8},
  {'color':0,'shortname':'udeconce', 'rivalName':'U. de Concepción', 'pts03':56, 'pon03':11.2,'pts04':60,'pon04':18,'pts05':46,'pon05':23,'pon':52.2},
  {'color':0,'shortname':'union', 'rivalName':'U. Española', 'pts03':49, 'pon03':9.8,'pts04':49,'pon04':14.7,'pts05':50,'pon05':25,'pon':49.5},
  {'color':0,'shortname':'everton', 'rivalName':'Everton', 'pts03':0, 'pon03':0,'pts04':43,'pon04':17.2,'pts05':53,'pon05':31.8,'pon':49},
  {'color':0,'shortname':'cobresal', 'rivalName':'Cobresal', 'pts03':43, 'pon03':8.6,'pts04':34,'pon04':10.2,'pts05':60,'pon05':30,'pon':48.8},
  {'color':0,'shortname':'wanderers', 'rivalName':'S. Wanderers', 'pts03':46, 'pon03':9.2,'pts04':50,'pon04':15,'pts05':46,'pon05':23,'pon':47.2},
  {'color':0,'shortname':'laserena', 'rivalName':'La Serena', 'pts03':0, 'pon03':0,'pts04':34,'pon04':13.6,'pts05':50,'pon05':30,'pon':43.6},
  {'color':0,'shortname':'rangers', 'rivalName':'Rangers', 'pts03':39, 'pon03':7.8,'pts04':33,'pon04':9.9,'pts05':46,'pon05':23,'pon':40.7},
  {'color':0,'shortname':'audax', 'rivalName':'Audax Italiano', 'pts03':43, 'pon03':8.6,'pts04':47,'pon04':14.1,'pts05':34,'pon05':17,'pon':39.7},
  {'color':0,'shortname':'palestino', 'rivalName':'Palestino', 'pts03':43, 'pon03':8.6,'pts04':35,'pon04':10.5,'pts05':41,'pon05':20.5,'pon':39.5}, 
   {'color':0,'shortname':'coquimbo', 'rivalName':'Coquimbo Unido', 'pts03':17, 'pon03':3.4,'pts04':47,'pon04':14.1,'pts05':44,'pon05':22,'pon':39.5},
              {'color':'#E4AB27','shortname':'puertomontt', 'rivalName':'Puerto Montt', 'pts03':40, 'pon03':8,'pts04':37,'pon04':11.1,'pts05':36,'pon05':18,'pon':37.1},
              {'color':'#E4AB27','shortname':'melipilla', 'rivalName':'Melipilla', 'pts03':0, 'pon03':0,'pts04':0,'pon04':0,'pts05':37,'pon05':37,'pon':37},
               {'color':'#E42727','shortname':'sanfelipe', 'rivalName':'U. San Felipe', 'pts03':22, 'pon03':4.4,'pts04':32,'pon04':9.6,'pts05':41,'pon05':20.5,'pon':34.5},
              {'color':'#E42727','shortname':'temuco', 'rivalName':'Dep. Temuco', 'pts03':28, 'pon03':5.6,'pts04':45,'pon04':13.5,'pts05':36,'pon05':18,'pon':34.1},
              ]

    };
  }

  componentDidMount() {
		this.getKits();
		let _newtable = this.sortTable(this.state.table1);
                this.setState({table1:_newtable});
		let newtable = this.sortTable(this.state.table2);
  		this.setState({table2:newtable});
		let newtable2 = this.sortTable(this.state.table3);
                this.setState({table3:newtable2});
	}

getKits(){

        fetch("https://www.registrosudec.com:5000/kits", {

    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      id_list: this.state.id_list
    })
    }).then(
                res => res.json()
                )
  .then(
    (result) => {
        console.log(result)
        this.setState({ 
        kits: result['kits']}) //[{path:"45.png", kit:yellow, short:"blue", soc$
    },
    // Nota: es importante manejar errores aqu   y no en
    // un bloque catch() para que no interceptemos errores
    // de errores reales en los componentes.
    (error) => {
      console.log(error);
      this.setState({fecha: []})
    }
  );
}


  handleChange(val){
    console.log(val);
    if(val===1){
      this.setState({showCards:true});
    }
    else{
      this.setState({showCards:false});
    }
  }

comeBack(){
this.setState({path:this.state.path});
}

subText(color, text){

let comp = [];
comp.push(

	<Row className="justify-content-md-center">
            <Col lg={3} xl={3} >

        <Table bordered={ false } size="sm">
        <tr style={{border: 'none', textAlign: 'rigth' }}>
        <td bgcolor={color} style={{width:'20px'}}>
        </td>
        <td style={{border: 'none', textAlign: 'center'}}> {text} </td>
        </tr>
        </Table>
        </Col>
        </Row>



)
return comp;

}


sortTable(table){
       let aux;
      for(let i=table.length-1;i>0;i--){
             for(let j =0; j<i; j++){
                 if( (table[j].pts < table[j+1].pts) || 
                     ((table[j].pts === table[j+1].pts) && (table[j].dif < table[j+1].dif)) ||
                     ((table[j].pts === table[j+1].pts) && (table[j].dif === table[j+1].dif) && (table[j].gf < table[j+1].gf))){
			aux = table[j+1];
			table[j+1] = table[j];
                        table[j] = aux;
		} 
	     }		
	}
return table;

}


render(){


  let subT = this.subText('#295e1e', 'Clasificado a Play-Off');
  let subC = this.subText('#135683', 'Clasificado a Play-Off y a Libertadores 2006');
  let subP = this.subText('#E4AB27', 'Juega Liguilla Promoción');
  let subD = this.subText('#E42727', 'Desciende a Primera B');
  return(

	<div style={{textAlign: 'center' }}>
	 <div style={{ height: '50px' }}></div>
        <div className="mytitlepartidos">  Indumentaria UDEC Clausura 2005</div>
        <div style={{ height: '50px' }}></div> 

        <div style={{display: 'inline-block' }}>
        <table style={{textAlign: 'center' }}>
        <tr>
           {this.state.kits.map((i) => {
                   return ( <td> <Image  className="escudo-home" src={this.state.kit_path+i['path']+".png"}/> </td>)
            })}
        </tr>
        <tr>
        {this.state.kits.map((i) => {
                   return ( <td> <Image  className="myshort" src={this.state.kit_path+i['short']+".png"}/> </td>)
            })}
        </tr>
        <tr>
        {this.state.kits.map((i) => {
                   return ( <td> <Image  className="myshort" src={this.state.kit_path+'socks-'+i['socks']+".png"}/> </td>)
            })}
        </tr>

        <tr>
                {this.state.kits.map((i) => {
                   return ( <td class="circle"> {i['count']} </td>)
            })}
        </tr>
        </table>
        </div>

      <div style={{ height: '50px' }}></div>
	<div className="mytitlepartidos"> Grupo 4 </div>
	<div style={{ height: '10px' }}></div>
	{<Tabla teams={this.state.table1} />}
        <div style={{ height: '10px' }}></div>
         {subT}


	<div style={{ height: '50px' }}></div>
	<div className="mytitlepartidos"> Tabla General</div>
	<div style={{ height: '10px' }}></div>
        {<Tabla teams={this.state.table2} />}

	<div style={{ height: '10px' }}></div>
	{subC}
	{subT}
	
	<div style={{ height: '50px' }}></div>
        <div className="mytitlepartidos"> Tabla Descenso 2005</div>
        <div style={{ height: '10px' }}></div>
        {<TablaProm2005 teams={this.state.table3} />}

        <div style={{ height: '10px' }}></div>
	{subP}
        {subD}


	<div style={{ height: '100px' }}></div>
	<div className="mytitlepartidos">  Partidos UDEC Clausura 2005</div>
	<div style={{ height: '10px' }}></div>

	<ToggleButtonGroup type="radio" name="options" defaultValue={1} onChange={this.handleChange}>
            <ToggleButton variant="secondary" value={1}>Tarjetas</ToggleButton>
            <ToggleButton variant="secondary" value={2}>Listado</ToggleButton>
          </ToggleButtonGroup>
	 <div style={{ height: '10px' }}></div>
	<Container>
	<div className={this.state.showCards ? '': 'hiddenCard'}>
           <MatchCardGroup id_list={this.state.id_list}></MatchCardGroup>
         </div>
         <div className={this.state.showCards ? 'hiddenCard': ''}>

           <MatchList id_list={this.state.id_list} showName={true}></MatchList>

         </div>
	</Container>

	<div style={{ height: '100px' }}></div>
        <div className="mytitlepartidos">  Jugadores UDEC Clausura 2005</div>
        <div style={{ height: '10px' }}></div>

	<Players torneo="Clausura 2005" />
     </div>


  )
}

}
export default Clausura2005;
